$(".tabs-btn button").click(function () {
  $(".tabs-btn button").removeClass("active-tab");
  $(this).addClass("active-tab");
});

$(".select-off").click(function () {
    $(".select-off").removeClass("active-off");
    $(this).addClass("active-off");
  });




// $(".accordion-heading").click(function () {
//   $(".accordion-content").slideToggle();
// });

$(".accordion-content").hide(); // Sab content initially hide kar do
$(".accordion-heading").click(function () {
  // Pehle sab accordion close karo
  $(".accordion-content").slideUp();

  // Agar clicked element already open nahi hai toh usko open karo
  if (!$(this).next(".accordion-content").is(":visible")) {
    $(this).next(".accordion-content").slideDown();
  }
});


$('.slider').slick({
    dots: false,
    arrows:true,
    infinite: true,
    speed: 300,
    slidesToShow: 2.2,
    slidesToScroll: 1,
  autoplay:true,
  autoplaySpeed:1500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });


  $('.new-slider').slick({
    dots: false,
    arrows:true,
    infinite: true,
    speed: 300,
    slidesToShow: 4.2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });